import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { UserData, userDataType } from '../../store/UserData/UserData'
import { MenuData } from '../../store/MenuData/MenuData'
import AsideBar from '../AsideBar/AsideBar'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { logout } from '@/api/apiList/admini'
import { delCookie, setCookie, getCookie, isWechar, getQuery } from '@/utils/utils'
import NativeSelect from '@material-ui/core/NativeSelect';
import { java_url } from '@/api/url.js'
import { computed } from 'mobx'
import eventBus from '@/utils/eventBus';
import './BHeader.scss'
import { getMerchantList } from "@/api/apiList/admini.js";
// import { getCookie,setCookie } from "@/utils/utils";
import store from "@/store";
@observer
@inject((store: { UserData: UserData, MenuData: MenuData }) => {
    return {
        userData: store.UserData.userData,
        changeUserData: store.UserData.changeUserData,
        menuList: store.MenuData.menuList
    }
})
export default class BHeaders extends React.PureComponent<{
    userData: userDataType,
    changeUserData: (userData: userDataType) => void,
    menuList: newBackMenuType
}, { anchorEl: null | HTMLElement, isOpenAside: boolean, curTopMenu: number, copyMenuId: number | null }>{
    state = {
        anchorEl: null,
        isOpenAside: false,
        curTopMenu: 0, // 当前选中的顶部菜单id
        copyMenuId: null, // 当点开一级菜单选择时保存的前菜单信息，在取消选择时会跳回来
    }
    private handleClose = (type?: string) => {
        this.setState({
            anchorEl: null
        })
        if (type === 'logout-test') {
            delCookie('token')
            window.location.reload()
        }
        if (type === 'logout') {
            delCookie('userName') && delCookie('roleType') && delCookie('token')
            window.location.href = `//login.batmobi.cn/login?service=${java_url}/cas/v1`
        }
    }
    private handleChange = (type?: string) => {
        delCookie('merchant-id')
            setCookie("merchant-id", type, 1);
            window.location.href="/"
    }
    private handleMenu = (e: React.MouseEvent<HTMLElement>) => {
        this.setState({ anchorEl: e.currentTarget })
    }
    private openAside = (type?: boolean) => {
        this.setState({
            isOpenAside: type != undefined ? !!type : !this.state.isOpenAside
        }, () => {
            if(this.state.isOpenAside){
                return
            }
            // 取消选择重置之前状态
            const oldMenu = this.props.menuList.pubFolders.find(v => v.previousID == this.state.copyMenuId);
            // 如果老菜单里还有这个文件夹，证明点击了取消，没有切换到新菜单去
            if (oldMenu && oldMenu.folders.some(v => v.folderID == getQuery('folderID'))) {
                this.setState({
                    curTopMenu: this.state.copyMenuId!,
                    copyMenuId: null
                })
                eventBus.emit('configMenu', this.props.menuList.pubFolders.find(v => v.previousID == this.state.copyMenuId).folders);
            }
        })
    }
    async componentWillMount() {
       if (getCookie('merchant-id')) {
        const res = await getMerchantList();
        if (res && res.code == 0) {
            if (!getCookie("merchant-id") || !(res.data && res.data.find((item:any) => item.user_id ==getCookie("merchant-id")))) {
                setCookie("merchant-id", res.data[0].user_id, 1);
            } 
            store.UserData.changeUserData({
                ...store.UserData,
                merchantList: res.data
            });
        }
       }
    }
    componentWillUpdate(nextProp) {
        if (this.props.menuList.topFolders.length != nextProp.menuList.topFolders.length) {
            
            const { topFolders } = nextProp.menuList;
            // 如果首页进来默认打开第二个顶层文件夹,否则根据二级文件夹去匹配
            if (!getQuery('folderID')) {
              
                this.setState({
                    curTopMenu: topFolders[0].folderID
                })
            }
            else {
                const curMenu = nextProp.menuList.pubFolders.find(v => v.folders.some(vv => vv.folderID == getQuery('folderID')));
                this.setState({
                    curTopMenu: curMenu.previousID
                })
            }
        }
    }
    render() {
        const { userData } = this.props
        const { handleClose, handleMenu, openAside,handleChange } = this;
        const { anchorEl, isOpenAside, curTopMenu } = this.state;
        const { menuList } = this.props;
        const TopMenu = () => <NativeSelect value={curTopMenu} className={"topSelect"}
            onChange={(event: React.ChangeEvent<{ value: string }>) => {
                // 保存一份前菜单，防止返回
                this.setState({
                    copyMenuId: curTopMenu
                })
                const previousID = Number(event.target.value)
                this.setState({
                    curTopMenu: previousID
                }, () => {
                    eventBus.emit('configMenu', menuList.pubFolders.find(v => v.previousID == previousID).folders);
                    openAside()
                })
            }}>
            {
                menuList.topFolders.map(topFolder => <option key={topFolder.folderID}
                    value={topFolder.folderID}>
                    {topFolder.folderName}
                </option>)
            }
        </NativeSelect>
        const open = Boolean(anchorEl);
        return <header className="Bheader">
            <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="menu" onClick={openAside.bind(this)}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="inherit">
                        <TopMenu />
                    </Typography>
                    <div
                        style={{ textAlign: 'right', flexGrow: 1 }}>
                        <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            style={{color:'#fff'}}
                        >
                            {/* <AccountCircle /> */}
                            {(userData && userData.merchantList) && userData.merchantList.find((item:any) => item.user_id == getCookie('merchant-id')) && userData.merchantList.find((item:any) => item.user_id == getCookie('merchant-id')).user_name|| '企'}
                            {/* <span className="userName">{userData.userName}</span> */}
                        </IconButton>
                         <Menu
                            anchorEl={anchorEl}
                            id="menu-appbar"
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={open}
                            onClose={handleClose}
                        >
                            {(userData && userData.merchantList) && userData.merchantList.map((item:any) => <MenuItem onClick={handleChange.bind(this, item.user_id)}> {item.user_name}</MenuItem>)}
                            {/* {<MenuItem onClick={handleClose.bind(this, 'logout-test')}>清理cookie</MenuItem>} */}
                            {!isWechar &&<MenuItem onClick={handleClose.bind(this, 'logout')}>登出</MenuItem>}
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <AsideBar isOpenAside={isOpenAside} openAside={openAside}></AsideBar>
        </header>
    }
}
